const supportStepOne = document.querySelector(".support-form--first-step");

if (supportStepOne) {
  const supportStepTwo = document.querySelector(".support-form--second-step");
  const nextButton = supportStepOne.querySelector("#nextButton");
  const buttonText = nextButton.innerHTML;
  nextButton.addEventListener("click", event => {
    event.preventDefault();
    supportStepTwo.parentElement.classList.toggle(
      "support-form__animation-box--open"
    );
    supportStepTwo.classList.toggle("hidden");
    supportStepTwo.scrollIntoView(true);
    nextButton.innerHTML = supportStepTwo.classList.contains("hidden")
      ? buttonText
      : "Avbryt";
  });
}
